import { cn } from '@/lib/utils';

/**
 * Shared route / shell loading skeleton (Arcadia panel chrome + muted pulse).
 */
export function AppLoadingSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-col h-screen overflow-hidden bg-arc-bg', className)}>
      <div className="h-12 bg-arc-panel border-b border-arc-border animate-pulse" />
      <div className="flex flex-1 overflow-hidden">
        <div className="hidden md:flex w-64 flex-col border-r border-arc-border bg-arc-panel p-4 gap-3">
          <div className="h-8 w-3/4 rounded bg-arc-panel-soft animate-pulse" />
          <div className="h-8 w-full rounded bg-arc-panel-soft animate-pulse" />
          <div className="h-8 w-5/6 rounded bg-arc-panel-soft animate-pulse" />
        </div>
        <main className="flex-1 overflow-hidden flex flex-col items-center justify-center gap-3 p-6">
          <div className="h-10 w-48 max-w-full rounded-md bg-arc-panel-soft animate-pulse" />
          <div className="h-4 w-64 max-w-full rounded bg-arc-panel-soft/80 animate-pulse" />
        </main>
      </div>
    </div>
  );
}

export function AppRouteLoadingSkeleton() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center min-h-[50vh] gap-3 px-6 py-12">
      <div className="h-10 w-56 max-w-full rounded-md bg-arc-panel-soft animate-pulse" />
      <div className="h-4 w-40 max-w-full rounded bg-arc-panel-soft/70 animate-pulse" />
    </div>
  );
}
